import { render, staticRenderFns } from "./OrgWantedStatsByType.vue?vue&type=template&id=5fa6b614&scoped=true&"
import script from "./OrgWantedStatsByType.vue?vue&type=script&lang=js&"
export * from "./OrgWantedStatsByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa6b614",
  null
  
)

export default component.exports